import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useClient } from '../uni-comms-api/hooks/authentication';

function RequireActiveSubscription({ children }) {
  const { client } = useClient();
  const location = useLocation();

  const isActiveSubscription =
    client?.subscription?.active && client?.subscription?.name !== 'free';

  if (client && !isActiveSubscription) {
    if (!location.pathname.startsWith('/plan')) {
      return <Navigate to="/plan" replace />;
    }
  }

  return children || <Outlet />;
}

export default RequireActiveSubscription;
